import React from 'react';
import { useNavigate } from 'react-router-dom';

const Landing = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#fdf6ec] flex items-center justify-center px-4">
      <div className="w-full max-w-sm text-center">

        <div className="mb-3">
          <span className="bg-[#ff6b35] text-white text-xs font-black tracking-[3px] uppercase px-3 py-1 rounded">
            FILMQUEST
          </span>
        </div>

        <h1 className="text-4xl font-black text-[#1a1a1a] mt-3 mb-1 leading-tight">
          Connect the Stars
        </h1>
        <p className="text-sm text-[#888] mb-8">How many hops does it take?</p>

        <div className="flex flex-col gap-3 mb-6">
          <button
            onClick={() => navigate('/random')}
            className="bg-[#ff6b35] text-white font-black text-base py-3 px-6 rounded-lg border-[3px] border-[#1a1a1a] shadow-[4px_4px_0_#1a1a1a] hover:shadow-[2px_2px_0_#1a1a1a] transition-shadow"
          >
            🎲 Random Actors
          </button>
          <button
            onClick={() => navigate('/selected')}
            className="bg-white text-[#1a1a1a] font-black text-base py-3 px-6 rounded-lg border-[3px] border-[#1a1a1a] shadow-[4px_4px_0_#1a1a1a] hover:shadow-[2px_2px_0_#1a1a1a] transition-shadow"
          >
            🎯 Pick Your Actors
          </button>
        </div>

        <button
          onClick={() => navigate('/popular')}
          className="text-[#ff6b35] text-sm font-bold underline"
        >
          Browse popular actors →
        </button>

      </div>
    </div>
  );
};

export default Landing;
